import React ,{useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios'
import '../assets/css/style.css';
import BASE_URL from '../context/AppConfig';




const Footer = () => {
    const [info, setInfo] =useState([])

  useEffect(() => {
    axios.get(`${BASE_URL}/offices/`)
    .then((res) => {
      setInfo(res.data);
    })
    .catch((err) => {
      console.log(err)
    });
  },[]);
    return (
        <div className="footer wow fadeIn" data-wow-delay="0.3s">
           
            <div className="container">
                <div className="row">
                    <div className="col-md-6 col-lg-3">
                        <div className="footer-contact">
                            <h2>Office Contact</h2>
                            <p><i className="fas fa-map-marker-alt"></i>{info[0]?.address} Noida, Uttar Pradesh</p>
                            <p><i className="fa fa-phone-alt"></i>{info[0]?.phone} 9818591361</p>
                            <p><i className="fa fa-envelope"></i>{info[0]?.email} info@saaraconstructions.com</p>
                            
                            
                            <div className="footer-social">
                                <a href=""><i className="fab fa-twitter"></i></a>
                                <a href=""><i className="fab fa-facebook-f"></i></a>
                                <a href=""><i className="fab fa-youtube"></i></a>
                                <a href=""><i className="fab fa-instagram"></i></a>
                                <a href=""><i className="fab fa-linkedin-in"></i></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                        <div className="footer-link">
                            <h2>Services Areas</h2>
                            <a href="">Building Construction</a>
                            <a href="">House Renovation</a>
                            <a href="">Architecture Design</a>
                            <a href="">Interior Design</a>
                            <a href="">Painting</a>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                        <div className="footer-link">
                            <h2>Useful Pages</h2>
                            <a href="">About Us</a>
                            <a href="/contact">Contact Us</a>
                            <a href="/service">Our Services</a>
                            <a href="">Projects</a>
                            <a href="">Testimonial</a>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                        <div className="newsletter">
                            <h2>Newsletter</h2>
                            <p>
                                Get updates on new projects, construction tips, and industry insights.
                            </p>
                            <div className="form">
                                <input className="form-control" placeholder="Email here" />
                                <button className="btn">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container footer-menu">
                <div className="f-menu">
                    <a href="">Terms of use</a>
                    <a href="">Privacy policy</a>
                    <a href="">Cookies</a>
                    <a href="">Help</a>
                    <a href="">FQAs</a>
                </div>
            </div>
            <div className="container copyright">
                <div className="row">
                    <div className="col-md-6">
                        <p>&copy; <a href="#">Saara constructions</a>, All Right Reserved.</p>
                    </div>
                    <div className="col-md-6">
                        <p>Designed By <a href="https://utsav2501.github.io/portfolio/" target='_blank'>Utsav Kumar & Niraj Kumar</a></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;